<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">
      <img src="/dashboard/assets/images/loja-logo-exemplo.png" />
      <span>Minha Loja</span>
    </a>
  </div>
</div>

<div class="header-container">
  <api-status-indicator></api-status-indicator>
  <nb-actions size="small">
    <nb-action 
      class="control-item" 
      icon="person-outline" 
      [nbContextMenu]="userMenuItems"
      nbContextMenuTag="user-menu"
    ></nb-action>
    <nb-action class="control-item" icon="keypad-outline"></nb-action>
    
    
    
    <!-- <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               name="Fernando Silva"
               [picture]="user?.picture">
      </nb-user>
    </nb-action> -->
  </nb-actions>
</div>
